import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityPersonasJuridicaState
} from './entity-personas-juridica.state';
import { entityPersonasJuridicaAdapter } from './entity-personas-juridica.state';
import {
  entityPersonasJuridicaLoadRequest,
  entityPersonasJuridicaLoadSuccess,
  entityPersonasJuridicaLoadFailure,
  entityPersonasJuridicaAddFailure,
  entityPersonasJuridicaAddRequest,
  entityPersonasJuridicaAddSuccess,
  entityPersonasJuridicaChangeFailure,
  entityPersonasJuridicaChangeRequest,
  entityPersonasJuridicaChangeSuccess,
  entityPersonasJuridicaDeleteFailure,
  entityPersonasJuridicaDeleteRequest,
  entityPersonasJuridicaDeleteSuccess
} from './entity-personas-juridica.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityPersonasJuridicaLoadRequest, (state: any) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasJuridicaLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasJuridicaLoadSuccess, (state, { items }) =>
    entityPersonasJuridicaAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityPersonasJuridicaAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasJuridicaAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasJuridicaAddSuccess, (state, { item }) => {
    return entityPersonasJuridicaAdapter.addOne(item.persona_juridica, {
      ...state,
      isLoading: false,
      error: null
    });
  }),
  // change
  on(entityPersonasJuridicaChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasJuridicaChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasJuridicaChangeSuccess, (state, { item }) => {
    return entityPersonasJuridicaAdapter.upsertOne(item.persona, {
      ...state,
      isLoading: false,
      error: null
    })
  }
  ),
  // delete
  on(entityPersonasJuridicaDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasJuridicaDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasJuridicaDeleteSuccess, (state, { item }) =>
    entityPersonasJuridicaAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function personasJuridicaReducer(
  state: EntityPersonasJuridicaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
